import React from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';
import { debuglog } from 'util';
import { userService } from '../_services';

class CompliancePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            IsDisable: true,
            error: '',
            userdata: JSON.parse(localStorage.getItem('user'))
        }
    }
    accordian = (e) => {
        try {
            $(e.target).parents('.card').toggleClass('active');
            $(e.target).parents('.card').find('.card-body').slideToggle();
            $(e.target).parents('.card').siblings().find('.card-body').slideUp();
            $(e.target).parents('.card').siblings().removeClass('active');
        }
        catch (error) {
            this.setState({ error: 'Something went wrong. Please try later.' });
        }
    }
    handleScroll = (e) => {
        try {
            var scrollTop = e.target.scrollTop.toFixed();
            const bottom = e.target.scrollHeight - Math.ceil(e.target.scrollTop) === e.target.clientHeight;
            if (bottom) {
                this.setState({ IsDisable: false });
            }
        }
        catch (error) {
            this.setState({ error: 'Something went wrong. Please try later.' });
        }
    }
    fetchComplianceData = () => {
        let userDataChange = this.state.userdata;
        userDataChange.iscompopup = true;
        let changedData = JSON.stringify(userDataChange);
        localStorage.setItem('user', changedData);
        this.setState({ IsDisable: true, userdata: userDataChange });
        try {
            userService.Accept_Comp_Popup(parseInt(this.state.userdata.wholesaler_Id), 0, this.state.userdata.userrole, 'submit').then(
                apidata => {
                    if (apidata.length > 0) {
                        if (apidata[0].isAccepted == true) {
                            this.setState({ IsDisable: false });
                            this.props.closePopup();
                        }
                    } else {
                        this.setState({ error: 'Something went wrong. Please try later.' });
                    }
                });
        } catch (error) {
            this.setState({ error: 'Something went wrong. Please try later.' });
        }
    }

    render() {
        const { IsDisable, error } = this.state;
        return (

            <div className='tool-section compliance'>
                <div className='popup report-section'>
                    <div className='popup_inner'>
                        <h1>{this.props.text}<span>{this.props.sub}</span></h1>
                        <div className="faq-section">
                            <div className="container">
                                <div className="accordion" onScroll={this.handleScroll}>
                                    <div className="card first">
                                        <span onClick={this.accordian}>Can I offer a doctor, pharmacist or other health care worker or pharmacy employee money or gifts to promote the GlicRx Program?</span>
                                        <div className="card-body">
                                            <p>No! Absolutely not.</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>Can I get a doctor, pharmacist or other health care worker or pharmacy employee to become an affiliate of the GlicRx Program?</span>
                                        <div className="card-body">
                                            <p>No!  No doctor, nurse, pharmacist, pharmacy intern or tech, or any other health care employee can serve as a marketer of the GlicRx Program.</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>What if a doctor, pharmacist, healthcare worker or pharmacy employee asks me for payment in exchange for promoting the GlicRx Program?</span>
                                        <div className="card-body">
                                            <p>Politely decline and make it clear that such arrangements are against company policy.</p>
                                            <p>You should report such requests to <a href="mailto:compliance@glichealth.com">compliance@glichealth.com</a>.  If you would prefer to make a confidential, anonymous report, you can use one of these reporting options:</p>
                                            <ul>
                                                <li>o  Website: <a target="_blank" href="https://www.lighthouse-services.com/_StandardCustomURL/LHILandingPage.asp">www.lighthouse-services.com/glichealth.</a></li>
                                                <li>
                                                    o	Toll-Free Telephone:
                                        <ul>
                                                        <li>o	English speaking: <b>833-401-0002</b></li>
                                                        <li>o	Spanish speaking: <b>800-216-1288</b></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>Do I have to get your approval of my web site or social media posts?</span>
                                        <div className="card-body">
                                            <p>Yes!  In order for us to ensure our marketing network complies with all applicable federal, state and local regulations, we require every marketer – and every contractor of every marketer – to submit their marketing materials – which includes, for example, your web site, social media posts, and marketing emails.  Failure to do so will subject your contract to immediate termination.</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>What if I forget to get pre-approval of my social media or other online posts?</span>
                                        <div className="card-body">
                                            <p>You must immediately delete any such posts (whether inadvertent or not) and submit such inappropriately posted marketing material to Glic Health for review and approval.</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>What if one of my subcontractors uses marketing material that they did not submit for pre-approval?</span>
                                        <div className="card-body">
                                            <p>If you learn that one of your contractors has failed to secure pre-approval of their marketing material, you must immediately (1) cause that contractor to cease immediately the use of any such material and (2) report the same to Glic Health – together with the unapproved marketing materials – for review.  Any marketer – and any subcontractor of any marketer – is subject to immediate termination for failure to have your marketing material pre-approved by Glic Health.</p>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>What if a pharmacist or other pharmacy employee asks me or a member of my team for a referral fee or some other payment or gift in connection with the GlicRx Program?</span>
                                        <div className="card-body">
                                            <p>You must report any such request – or even the suggestion of such a request – immediately to <a href="mailto:compliance@glichealth.com">compliance@glichealth.com</a>.  If you would prefer to make a confidential, anonymous report, you can use one of these reporting options:</p>
                                            <ul>
                                                <li>o  Website: <a target="_blank" href="https://www.lighthouse-services.com/_StandardCustomURL/LHILandingPage.asp">www.lighthouse-services.com/glichealth.</a></li>
                                                <li>
                                                    o	Toll-Free Telephone:
                                        <ul>
                                                        <li>o	English speaking: <b>833-401-0002</b></li>
                                                        <li>o	Spanish speaking: <b>800-216-1288</b></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>What if I have concerns that someone is out there distributing the GlicRx Program in violation of GlicRx compliance standards?</span>
                                        <div className="card-body">
                                            <p>If you have any such concerns, please contact <a href="mailto:compliance@glichealth.com">compliance@glichealth.com</a> immediately so that we can address the situation as soon as possible.  If you would prefer to make a confidential, anonymous report, you can use one of these reporting options:</p>
                                            <ul>
                                                <li>o  Website: <a target="_blank" href="https://www.lighthouse-services.com/_StandardCustomURL/LHILandingPage.asp">www.lighthouse-services.com/glichealth.</a></li>
                                                <li>
                                                    o	Toll-Free Telephone:
                                        <ul>
                                                        <li>o	English speaking: <b>833-401-0002</b></li>
                                                        <li>o	Spanish speaking: <b>800-216-1288</b></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card">
                                        <span onClick={this.accordian}>What if I have questions about compliance or about what marketing activities I can engage in?</span>
                                        <div className="card-body">
                                            <p>If you have any such questions, please contact your customer success manager, who can direct your questions to the appropriate GlicRx professional.  Of course, you can always reach out to <a href="mailto:compliance@glichealth.com">compliance@glichealth.com</a> as well.</p>
                                        </div>
                                    </div>
                                    <span class="further"><span>Need Further Assistance?</span><a href="mailto:info@glichealth.com">Info@glichealth.com</a></span>
                                </div>
                                <button onClick={this.fetchComplianceData} disabled={IsDisable} className="btn">I Understand</button>
                                {error &&
                                    <div className={'alert alert-danger m-group'}>{error}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CompliancePopup;